export default __webpack_public_path__ + "static/media/stars.ba7084b0.svg";